"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInRange = void 0;
var isInRange = function (min, max) { return function (target) {
    return min <= target && target <= max;
}; };
exports.isInRange = isInRange;
